/* eslint-disable no-console */
console.log("Hello World! (from create-block-blocks-gamestore block)");
/* eslint-enable no-console */
